import React from "react";
import "./test.css"

const TestPage = () => {
    return (
        <div className="container">
            <img className="logo" src="/public/generated/nostra_logo.png" alt="Nostra logo"/>
            <h1>Rejoindre une session</h1>
            <p>Flashez le QR code sur votre TV ou entrez le code ci-dessous</p>
            <div className="input-container">
                <input type="text" placeholder="CODE (EX: 7EA3)" className="code-input"/>
            </div>
            <button className="confirm-button">Confirmer</button>
        </div>
    );
};

export default TestPage;
